import { hexToRGBA } from "@utils/hex-to-rgba"

export const primaryColors = [
    {
        main: '#C778DD',
        light: '#d79fe7',
        dark: "#572aa5",
        contrastText: '#FFFFFF',
    },
    {
        main: '#ABB2BF',
        light: '#cbd1da',
        dark: '#1d232d',
        contrastText: '#FFFFFF',
    },
    {
        main: '#FFFB97',
        light: '#fdfbc0',
        dark: "#f9f348",
        contrastText: '#000000',
    },
    {
        main: '#FFA07A',
        light: '#FFA07A',
        dark: "#FFA07A",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FFD700',
        light: '#FFD700',
        dark: "#FFD700",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF6347',
        light: '#FF6347',
        dark: "#FF6347",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF4500',
        light: '#FF4500',
        dark: "#FF4500",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF8C00',
        light: '#FF8C00',
        dark: "#FF8C00",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF69B4',
        light: '#FF69B4',
        dark: "#FF69B4",
        contrastText: '#FFFFFF',
    },
]
export const secondaryColors = [
    {
        main: '#ABB2BF',
        light: '#cbd1da',
        dark: '#1d232d',
        contrastText: '#FFFFFF',
    },
    {
        main: '#C778DD',
        light: '#d79fe7',
        dark: "#572aa5",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FFFB97',
        light: '#fdfbc0',
        dark: "#f9f348",
        contrastText: '#000000',
    },
    {
        main: '#FFA07A',
        light: '#FFA07A',
        dark: "#FFA07A",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FFD700',
        light: '#FFD700',
        dark: "#FFD700",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF6347',
        light: '#FF6347',
        dark: "#FF6347",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF4500',
        light: '#FF4500',
        dark: "#FF4500",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF8C00',
        light: '#FF8C00',
        dark: "#FF8C00",
        contrastText: '#FFFFFF',
    },
    {
        main: '#FF69B4',
        light: '#FF69B4',
        dark: "#FF69B4",
        contrastText: '#FFFFFF',
    },
]
export const backgroundColors = ["#282C33", "#ABB2BF", "#004643", "#EFF0F3", "#BAE8E8", "#00214D", "#232946", "#FFFFFF", "#e3f2fd", "#f8f9fa", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"]
export const paperColors = ["#282C33", "#ABB2BF", "#004643", "#EFF0F3", "#BAE8E8", "#00214D", "#232946", "#FFFFFF", "#e3f2fd", "#f8f9fa", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"]
export const dividerColors = ["#ABB2BF", "#C778DD", "#FFFB97", "#FFA07A", "#FFD700", "#FF6347", "#FF4500", "#FF8C00", "#FF69B4"]
export const textColors = [
    {
        primary: '#000000',
        secondary: hexToRGBA('#000000', 0.8),
        disabled: '#FFFFFF',
    },
    {
        primary: '#FFFFFF',
        secondary: '#ABB2BF',
        disabled: '#000000',
    },
    {
        primary: '#152536',
        secondary: '#6C757D',
        disabled: '#CED4DA'

    }

]